import { useState } from "react";
import Header from "../../components/Header/Header";
import NoticeList from "../../features/Notice/components/NoticeList";
import useNotice from "#features/Notice/hooks/useNotice";
import useNoticeDetail from "#features/Notice/hooks/useNoticeDetail";
import NoticeDetail from "../../features/Notice/components/NoticeDetail";
import NoticePrevNext from "../../features/Notice/components/NoticePrevNext";

const NoticePage = () => {
  const [listId, setListId] = useState(null);
  const { noticeList, fetchMoreData, infinity, isMounted } = useNotice();
  const { notice } = useNoticeDetail({ listId });

  return (
    <section className="p-hasHeader">
      <Header title="공지사항" />
      {isMounted && !listId && (
        <NoticeList
          noticeList={noticeList}
          fetchMoreData={fetchMoreData}
          infinity={infinity}
          setListId={setListId}
        />
      )}
      {listId && (
        <div className="mt-10">
          <NoticeDetail noticeDetail={notice} />
          <NoticePrevNext
            prev={notice?.prev}
            next={notice?.next}
            setListId={setListId}
          />
        </div>
      )}
    </section>
  );
};

export default NoticePage;
